const contactInfo = [{
    FirstName: 'Demo',
    LastName: 'User',
    Email: 'demo-user@dinesafevt.co',
    PhoneNumber: '555-555-5555',
    Address: '123 Forest St',
    Address1: '',
    City: 'Forestville',
    StateProvince: 'VT',
    ZipCode: '05046',
    Country: 'Unites States',
  }, 
];

  const states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT',
  'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY',
   'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
   'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK',
   'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT',
   'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
   'Canada - AB',
   'Canada - BC',
   'Canada - MB',
   'Canada - NB',
   'Canada - NL',
   'Canada - NS',
   'Canada - NT',
   'Canada - NU',
   'Canada - ON',
   'Canada - PE',
   'Canada - QC',
   'Canada - SK',
   'Canada - YK',
  ];

   const contactInfoFields = [
    {
      "Fields": [
        {
          "FieldName": "FirstName",
          "ColumnSpan": 2,
          "IsRequired": true,
          "DisplayText": "First Name",
          "AttributeId": 919,
        },
        {
          "FieldName": "LastName",
          "ColumnSpan": 2,
          "IsRequired": true,
          "DisplayText": "Last Name",
          "AttributeId": 918,
          "sid_input_style": 521,
        },
        {
          "FieldName": "Email",
          "ColumnSpan": 2,
          "IsRequired": true,
          "DisplayText": "Email",
          "AttributeId": 920,
          "sid_input_style": 521,
        },
        {
          "FieldName": "Phone",
          "ColumnSpan": 2,
          "IsRequired": true,
          "DisplayText": "Phone",
          "AttributeId": 917,
          "sid_input_style": 521,
        },
        {
          "FieldName": "Address",
          "ColumnSpan": 4,
          "IsRequired": false,
          "DisplayText": "Address 1",
          "AttributeId": 9171,
          "sid_input_style": 521,
        },
        {
          "FieldName": "Address1",
          "ColumnSpan": 4,
          "IsRequired": false,
          "DisplayText": "Address 2",
          "AttributeId": 9172,
          "sid_input_style": 521,
        },
        {
          "FieldName": "City",
          "ColumnSpan": 4,
          "IsRequired": false,
          "DisplayText": "City",
          "sid_queAttributeIdstion": 9173,
          "sid_input_style": 521,
        },
        {
          "FieldName": "StateProvince",
          "ColumnSpan": 2,
          "IsRequired": false,
          "DisplayText": "State/Province",
          "AttributeId": 9174,
          "sid_input_style": 521,
        },
        {
          "FieldName": "ZipCode",
          "ColumnSpan": 2,
          "IsRequired": false,
          "DisplayText": "Postal Code",
          "AttributeId": 9175,
          "sid_input_style": 521,
        }
      ]
    },
  ];

  export default {
    getContactInfo() {
      return contactInfo;
    },
    getStates(){
      return states;
    },
    getContactInfoFields(){
      return contactInfoFields;
    },
  };


